var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        centerScreen: "",
        bus: _vm.busModal,
        persistent: "",
        centerAndDecreasesPadding: "",
        maxWidth: "600px",
        closeColor: "#8e8e8e",
        backgroundColor: "white"
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: {
                    primary: "",
                    loading: _vm.loading,
                    disabled: _vm.loading
                  },
                  on: { click: _vm.importar }
                },
                [_vm._v(" Importar ")]
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", { staticClass: "pb-6" }, [
        _c("div", { staticClass: "modal-title-container" }, [
          _c("span", { staticClass: "modal-title" }, [
            _vm._v("Importar Histórico")
          ])
        ]),
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            { staticClass: "pa-4" },
            [
              _vm.conversaName
                ? _c("div", { staticClass: "text-center mb-4" }, [
                    _c("div", { staticClass: "az-text-small az-muted" }, [
                      _vm._v("Conversa")
                    ]),
                    _c(
                      "div",
                      { staticClass: "az-text-primary az-size-14 font-medium" },
                      [_vm._v(" " + _vm._s(_vm.conversaName) + " ")]
                    )
                  ])
                : _vm._e(),
              _c("input-by-type", {
                staticClass: "align-icon-search mb-3",
                attrs: {
                  type: "autocomplete",
                  options: _vm.quantityOptions,
                  labelExternal: "Quantidade de mensagens",
                  dense: "",
                  outlined: "",
                  "hide-details": "",
                  disabled: _vm.loading,
                  "data-test": "quantity-select"
                },
                model: {
                  value: _vm.quantidade,
                  callback: function($$v) {
                    _vm.quantidade = $$v
                  },
                  expression: "quantidade"
                }
              }),
              _c("v-checkbox", {
                staticClass: "mt-0 mb-4",
                attrs: {
                  label:
                    "Recarregar do zero (apaga as mensagens atuais e reimporta)",
                  "hide-details": "",
                  dense: "",
                  disabled: _vm.loading,
                  "data-test": "reload-checkbox"
                },
                model: {
                  value: _vm.reload,
                  callback: function($$v) {
                    _vm.reload = $$v
                  },
                  expression: "reload"
                }
              }),
              _c(
                "GeneralAlert",
                {
                  key: _vm.generalAlertKey,
                  staticClass: "mb-3",
                  attrs: { status: "warning_v3" }
                },
                [
                  _c("div", { staticClass: "az-text-primary az-size-12" }, [
                    _vm._v(
                      " Pode levar alguns segundos. Duplicadas serão ignoradas. "
                    )
                  ])
                ]
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }